import Image from "next/image";

interface ListItemProps {
    title?: string;
    content?: string;
    icon: string;
    price?: string[];
}

export default function ListItem({ title, content, icon, price }: ListItemProps) {
    return (
        <>
            <div className=" justify-center items-start gap-2 inline-flex">
                <div className="w-10 h-10 justify-center items-center flex">
                    <Image
                        alt=""
                        width={20}
                        height={20}
                        src={icon}
                        className="w-10 h-10 relative flex-col justify-start items-start flex"
                    />
                </div>
                <div className="grow w-full shrink basis-0 flex-col justify-center items-center inline-flex">
                    <div className="self-stretch text-black text-lg lg:text-xl1 font-bold  leading-7 lg:leading-8.5">
                        {title}
                    </div>
                    <div className="self-stretch break-all lg:break-normal text-black text-lg lg:text-xl1 font-normal  leading-7 lg:leading-8.5">
                        {content}
                    </div>
                    <div className="self-stretch break-all lg:break-normal text-black text-lg lg:text-xl1 font-normal  leading-7 lg:leading-8.5">
                        {price?.map((price, indx) => {
                            // biome-ignore lint/suspicious/noArrayIndexKey: the price might be the same
                            return <p key={price + indx}>- {price}</p>;
                        })}
                    </div>
                </div>
            </div>
        </>
    );
}
